<template>
  <div class="input-container" :style="{ margin: margin, height: height }">
    <label :class="{ labelObrigatorio: !isComponenteValido }"> {{ label }}</label>
    <div v-if="temIcon" class="field">
      <p class="control has-icons-right">
        <input
          class="input"
          type="text"
          pattern="[0-9]{5}-[0-9]{3}"
          ref="inputCep"
          :id="id"
          :required="required"
          :placeholder="placeholder"
          :value="cepWithMask"
          :maxlength="9"
          :disabled="isLoading"
          :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
          @keydown="$event => ignorarInputInvalido($event)"
          @input="$event => setValue($event)"
        />
        <span class="icon is-small is-right">
          <i class="mdi" :class="classIcon"></i>
        </span>
      </p>
    </div>

    <div class="container-ipt-cep" v-else>
      <input
        class="input"
        type="text"
        pattern="[0-9]{5}-[0-9]{3}"
        ref="inputCep"
        :id="id"
        :placeholder="placeholder"
        :maxlength="9"
        :required="required"
        :class="{ inValida: !isComponenteValido }"
        :value="cepWithMask"
        :disabled="isDisabled || isLoading"
        :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
        @keydown="$event => ignorarInputInvalido($event)"
        @keyup="this.verificarSeInputEstaVazio(false)"
        @input="$event => setValue($event)"
      />

      <span
        v-if="isLoading"
        class="button is-loading loading-cep"
      />
    </div>
    
    <span v-if="tipLabel" class="tip-label is-size-7">{{ tipLabel }}</span>

    <div class="mensagemDeErro" v-if="showValidations">
      <slot name="mensagemDeErro">
        <span v-if="!isCepValido" class="campo-obrigatório">
          Insira um {{ label ? label : 'CEP' }} válido.
        </span>

        <span v-else-if="required && campoVazio" class="campo-obrigatório">
          {{ mensagemDeErro }}
        </span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfCepInput",
  emits: [ 'cepInformations', 'update:modelValue', 'update:isLoading' ],
  props: {
    label: String,
    placeholder: String,
    margin: String,
    height: String,
    temIcon: Boolean,
    classIcon: String,
    modelValue: String,
    required: {
      type: Boolean,
      default: true
    },
    id: String,
    tipLabel: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    mensagemCampoObrigatorio: {
      type: String,
      default: null
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(novo, antigo) {
        if(novo == antigo) return;
        this.isCepValido = this.isComponenteValido;
      }
    }
  },
  computed: {
    cepWithMask() {
      return this.aplicarMascara(this.modelValue); 
    },
    mensagemDeErro() {
      if (this.mensagemCampoObrigatorio) {
        return this.mensagemCampoObrigatorio;
      };
      return `${this.label? this.label : 'CEP' } é obrigatório.`;
    },
    isComponenteValido() {
      if(!this.showValidations) {
        return true;
      }
      
      if(this.required) {
        return !this.campoVazio && this.isCepValido;
      }

      return this.isCepValido;
    },
  },
  data() {
    return {
      campoVazio: false,
      isCepValido: false,
      showValidations: false,
      isLoading: false
    };
  },
  methods: {
    async setValue(event) {
      const inputValue = event.target.value;
      const mesmoValor = inputValue == this.cepWithMask;
      this.$emit('update:modelValue', inputValue);
      
      await this.$nextTick()
      this.isCepValido = this.verificarSeInputEValido();

      if(mesmoValor || !inputValue) return;
      this.getCepInformations();
    },
    async ignorarInputInvalido(event) {
      const key = event.key;
      if (!!key && (key.length == 1 || key == "Dead") && key.match(/[^\d]/g) != null) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      await this.setValue(event);
    },
    aplicarMascara(value) {
      if (!value) return '';
      value = value.replace(/^(\d{5})(\d{3})$/,"$1-$2")
      return value
    },
    verificarSeInputEstaVazio(isInterno) {
      if (!isInterno) {
        this.showValidations = true
      }
      this.campoVazio = !this.modelValue || this.modelValue.trim() == "";
      this.verificarSeInputEValido()
      return this.campoVazio;
    },
    verificarSeInputEValido() {
      return !this.$refs.inputCep.validity.patternMismatch;
    },
    
    limparValidacao() {
      this.campoVazio = false;
      this.showValidations = false;
    },
    
    limparInput() {
      this.modelValue == ''
    },

    async getCepInformations() {
      if(!this.isCepValido || !this.modelValue) return;
      this.setLoading(true);
      try {
        const cepService = await this.importCepService();
        const cepInformations = await cepService.getCepInformations(this.modelValue);
        this.$emit('cepInformations', cepInformations);
      } catch {}
      this.setLoading(false);
    },

    setLoading(valor) {
      this.isLoading = valor;
      this.$emit('update:isLoading', valor);
    },

    async importCepService() {
      const { cepService } = await import('../../service/cep-service')
      return cepService
    }
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}
.tip-label {
  color: #4a4a4a;
  vertical-align: top;
}

.loading-cep {
  border:0 none!important;
  outline: 0 none!important;
  padding: 0px;
  margin-left: -20px;
}

.container-ipt-cep {
  display: flex;
}
</style>
